import React from 'react';
import { NavLink } from 'react-router-dom';
// import { GoDotFill } from "react-icons/go";
const TitleHeader = ({ title,viewall, c_id}) => {
    return (
        <div>
            <h3 className='header-main-div'>
                <span className='header-heading'>{title}</span>
                <NavLink className={"text-decoration-none"} to={`/Category/${c_id}`}>
                 <div className='header-heading-viewall'>{viewall}</div>
                 </NavLink>
            </h3>
           
        </div>
    );
};

export default TitleHeader;